import __ from "lodash";
import React, { Component, Fragment } from "react";
import { Alert, Button, Col, FormControl, Modal, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { cekCookies } from "../../../../../actions";
import accountManagement from "../../../../../apis/accountManagement";
import akmApi from "../../../../../apis/akmApi";
import eduprimeApi from "../../../../../apis/eduprimeApi";
import { CONFIG, CONFIG_API_BE, URL_AKM } from "../../../../../config";
import AddIcon from "@material-ui/icons/Add";

import Loader from "../../../../Loader";
import LoaderModal from "../../../../modal/LoaderModal";
import Navbar from "../../../navbar/Navbar";
import Sidebar from "../../../sidebar/Sidebar";
import SchoolNpsnEditor from "./SchoolNpsnEditor";

import Select from "react-select";
import { Grid, Input, InputLabel } from "@material-ui/core";

const emptyAccountForm = () => ({
    idAdmin: null, namaAdmin: null, emailAdmin: null, passwordAdmin: null,
    usernameAdmin: null, teleponAdmin: null, saveError: "", saveUncertain: false,
});
const sameId = (left, right) => left != null && right != null && String(left) === String(right);
const unresolvedSaveMessage = "Hasil penyimpanan belum dapat dipastikan. Jangan kirim ulang; periksa daftar akun atau hubungi admin sistem.";

class MgtPsepSekolah extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            tahunAjaran: [],
            provinsi: [],
            kota: [],
            sekolah: [],
            kodeJenjangSekolah: null,
            namaSekolahSearch: null,
            taAktif: null,
            idProvinsi: null,
            idKabKota: null,
            idSekolah: null,
            listSekolah: [],
            listKabKota: [],
            listProvinsi: [],
            namaSekolah: null,
            openModal: false,
            ...emptyAccountForm(),
            isSaving: false,
            saveNotice: "",
        };
    }

    async componentDidMount() {
        await this.props.cekCookies();
        if (!__.isEmpty(this.props.account)) {
            this.fetchProvinsi();
            this.fetchTa();
        }
    }

    fetchTa = async () => {
        const respons = await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_LIST_TAHUN_AJARAN, {});
        if (respons) {
            if (!__.isEmpty(respons.data.data)) {
                this.setState({
                    tahunAjaran: respons.data.data,
                });
            }
        }
        respons.data.data.map((val, i) => {
            if (val.status === "1") {
                this.setState({ taAktif: val.kodeTahunAjaran });
            }
        });
    };

    fetchProvinsi = async () => {
        this.setState({ isFetching: true });
        const respons = await eduprimeApi.get(CONFIG_API_BE.API_GET_PROVINSI, {});
        if (respons) {
            if (!__.isEmpty(respons.data.list_provinsi)) {
                const dataProvinsi = { value: "", label: "Pilih Provinsi...", id: "idProvinsi", selected: "selected" };
                this.state.listProvinsi.push(dataProvinsi);
                respons.data.list_provinsi.map((val, i) => {
                    const dataProvinsi = { value: val.ID_PROVINSI, label: val.NAMA_PROVINSI, id: "idProvinsi" };
                    this.state.listProvinsi.push(dataProvinsi);
                });
            }
        }
        this.setState({ isFetching: false });
    };

    selectionSequence = 0;
    accountModalSequence = 0;
    accountSaveInFlight = false;
    unconfirmedAccountSaves = {};
    unmounted = false;
    componentWillUnmount() {
        this.selectionSequence += 1;
        this.accountModalSequence += 1;
        this.unmounted = true;
    }
    handleChangeSelect = async (e) => {
        if (!e || !["idProvinsi", "idKabKota", "idSekolah"].includes(e.id)) return;
        const name = e.id, id = e.value || null;
        const sequence = ++this.selectionSequence;
        this.accountModalSequence += 1;
        const patch = { ...emptyAccountForm(), [name]: id, isFetching: true, selectionError: "", saveNotice: "" };
        if (name === "idProvinsi") Object.assign(patch, { idKabKota: null, idSekolah: null, listKabKota: [], listSekolah: [], sekolah: [], namaSekolah: null, openModal: false });
        if (name === "idKabKota") Object.assign(patch, { idSekolah: null, listSekolah: [], sekolah: [], namaSekolah: null, openModal: false });
        if (name === "idSekolah") Object.assign(patch, { sekolah: [], namaSekolah: null, openModal: false });
        this.setState(patch);
        try {
            if (!id) return;
            if (name === "idProvinsi") {
                const response = await eduprimeApi.get(CONFIG_API_BE.API_GET_KAB_KOTA + id, { timeout: 15000 });
                if (sequence !== this.selectionSequence) return;
                const rows = response.data && response.data.list_kab_kota;
                if (!Array.isArray(rows)) throw new Error("invalid response");
                this.setState({ listKabKota: rows.map(row => ({ value: row.ID_KABUPATEN_KOTA, label: row.NAMA_KABUPATEN_KOTA, id: "idKabKota" })) });
            } else if (name === "idKabKota") {
                const response = await akmApi.get(URL_AKM.FETCH_SEKOLAH_BY_ID_KAB + id, { timeout: 15000 });
                if (sequence !== this.selectionSequence) return;
                if (!response.data || !response.data.errorSchema || response.data.errorSchema.errorCode !== URL_AKM.SUCCESS_ERROR_CODE || !Array.isArray(response.data.data)) throw new Error("invalid response");
                this.setState({ listSekolahArray: response.data.data, listSekolah: response.data.data.map(row => ({ value: row.idSekolah, label: row.namaSekolah, id: "idSekolah" })) });
            } else {
                const accounts = await this.readSchoolAccounts(id);
                if (sequence !== this.selectionSequence) return;
                this.setState({ sekolah: accounts, namaSekolah: accounts.sekolah.namaSekolah });
            }
        } catch (error) {
            if (sequence === this.selectionSequence) this.setState({ selectionError: "Data pilihan belum dapat dimuat. Pilih kembali wilayah atau sekolah untuk mencoba lagi." });
        } finally {
            if (sequence === this.selectionSequence) this.setState({ isFetching: false });
        }
    };

    handleOpenModal = (value = {}) => {
        this.accountModalSequence += 1;
        const existing = value && value.idAdmin != null;
        const unresolved = this.unconfirmedAccountSaves[this.state.idSekolah];
        this.setState({
            ...emptyAccountForm(), openModal: true, saveNotice: "", isSaving: this.accountSaveInFlight,
            idAdmin: existing ? value.idAdmin : null,
            namaAdmin: existing ? value.namaAdminUser : null,
            usernameAdmin: existing ? value.username : null,
            emailAdmin: existing ? value.emailAdminUser : null,
            teleponAdmin: existing ? value.teleponAdminUser : null,
            saveUncertain: !!unresolved, saveError: unresolved ? unresolvedSaveMessage : "",
        });
    };

    handleCloseModal = () => {
        this.accountModalSequence += 1;
        this.setState({ ...emptyAccountForm(), openModal: false });
    };

    handleChange = (e) => {
        if (this.accountSaveInFlight || this.state.saveUncertain) return;
        const { name, value } = e.target;
        if (!["namaAdmin", "usernameAdmin", "passwordAdmin", "emailAdmin", "teleponAdmin"].includes(name)) return;
        if (name === "usernameAdmin" && this.state.idAdmin != null) return;
        this.setState({ [name]: value });
    };

    readSchoolAccounts = async (schoolId) => {
        const response = await akmApi.get(URL_AKM.MANAGE_ACCOUNT_SCHOOL + schoolId, { timeout: 15000 });
        const body = response && response.data;
        const accounts = body && body.data;
        if (!body || !body.errorSchema || body.errorSchema.errorCode !== URL_AKM.SUCCESS_ERROR_CODE ||
            !accounts || !accounts.sekolah || !sameId(accounts.sekolah.idSekolah, schoolId) || !Array.isArray(accounts.akun)) {
            throw new Error("invalid account list");
        }
        return accounts;
    };

    isCurrentAccountModal = (sequence, schoolId) => !this.unmounted && this.state.openModal &&
        sequence === this.accountModalSequence && sameId(schoolId, this.state.idSekolah);

    matchesSavedAccount = (accounts, operation) => operation.accepted && accounts.akun.filter(account =>
        sameId(account.idAdmin, operation.idAdmin) && account.username === operation.username).length === 1;

    confirmAccountSave = (operation, accounts, sequence) => {
        delete this.unconfirmedAccountSaves[operation.schoolId];
        if (!this.isCurrentAccountModal(sequence, operation.schoolId)) return;
        const sameForm = this.state.usernameAdmin === operation.username &&
            (operation.requestedId == null ? this.state.idAdmin == null : sameId(this.state.idAdmin, operation.requestedId));
        this.setState({
            ...(sameForm ? { ...emptyAccountForm(), openModal: false } : { saveError: "", saveUncertain: false }),
            sekolah: accounts, namaSekolah: accounts.sekolah.namaSekolah,
            saveNotice: "Akun tersimpan dan sudah terkonfirmasi pada daftar akun sekolah. Periksa status akun sebelum login.",
        });
    };

    finishAccountRequest = (sequence, schoolId) => {
        this.accountSaveInFlight = false;
        if (this.unmounted) return;
        const patch = { isSaving: false };
        if (this.state.openModal && !this.isCurrentAccountModal(sequence, schoolId)) {
            const unresolved = this.unconfirmedAccountSaves[this.state.idSekolah];
            Object.assign(patch, { saveUncertain: !!unresolved, saveError: unresolved ? unresolvedSaveMessage : "" });
        }
        this.setState(patch);
    };

    handleSubmit = async (e) => {
        e.preventDefault();
        const schoolId = this.state.idSekolah;
        if (!this.state.openModal || !schoolId || this.accountSaveInFlight || this.unconfirmedAccountSaves[schoolId]) return;
        const sequence = this.accountModalSequence;
        const payload = {
            idAdmin: this.state.idAdmin ? this.state.idAdmin : null,
            namaAdminUser: this.state.namaAdmin,
            usernameAdmin: this.state.usernameAdmin,
            passwordAdmin: this.state.passwordAdmin,
            emailAdminUser: this.state.emailAdmin,
            telponAdmin: this.state.teleponAdmin,
        };
        // Retain only reconciliation metadata, never a password or response object.
        const operation = { schoolId, requestedId: payload.idAdmin, username: payload.usernameAdmin, accepted: false };
        this.unconfirmedAccountSaves[schoolId] = operation;
        this.accountSaveInFlight = true;
        this.setState({ isSaving: true, saveError: "", saveNotice: "", saveUncertain: false });
        let postCompleted = false;
        try {
            const response = await akmApi.post(URL_AKM.MANAGE_ACCOUNT_SCHOOL + schoolId, payload, { timeout: 20000 });
            postCompleted = true;
            const body = response && response.data;
            const code = body && body.errorSchema && body.errorSchema.errorCode;
            if (code && code !== URL_AKM.SUCCESS_ERROR_CODE) {
                const rejection = new Error("save rejected");
                rejection.accountSaveRejected = true;
                throw rejection;
            }
            const saved = body && body.data;
            if (code !== URL_AKM.SUCCESS_ERROR_CODE || !saved || !saved.idAdmin || !sameId(saved.idSekolah, schoolId) ||
                saved.usernameAdmin !== operation.username || (payload.idAdmin != null && !sameId(saved.idAdmin, payload.idAdmin))) {
                throw new Error("invalid save response");
            }
            operation.accepted = true;
            operation.idAdmin = saved.idAdmin;
            const accounts = await this.readSchoolAccounts(schoolId);
            if (!this.matchesSavedAccount(accounts, operation)) throw new Error("unconfirmed account");
            this.confirmAccountSave(operation, accounts, sequence);
        } catch (error) {
            const status = error && error.response && error.response.status;
            const rejected = (error && error.accountSaveRejected) || (!postCompleted && status >= 400 && status < 500 && status !== 408);
            if (rejected) delete this.unconfirmedAccountSaves[schoolId];
            if (this.isCurrentAccountModal(sequence, schoolId)) this.setState({
                saveUncertain: !rejected,
                saveError: rejected ? "Penyimpanan ditolak. Periksa data akun dan kewenangan Anda sebelum mencoba lagi." : unresolvedSaveMessage,
            });
        } finally {
            this.finishAccountRequest(sequence, schoolId);
        }
    };

    handleVerifySave = async () => {
        const schoolId = this.state.idSekolah;
        const operation = this.unconfirmedAccountSaves[schoolId];
        if (!operation || this.accountSaveInFlight) return;
        const sequence = this.accountModalSequence;
        this.accountSaveInFlight = true;
        this.setState({ isSaving: true });
        try {
            const accounts = await this.readSchoolAccounts(schoolId);
            if (this.matchesSavedAccount(accounts, operation)) {
                this.confirmAccountSave(operation, accounts, sequence);
            } else if (this.isCurrentAccountModal(sequence, schoolId)) {
                this.setState({ sekolah: accounts, namaSekolah: accounts.sekolah.namaSekolah, saveError: "Daftar akun sudah dimuat, tetapi hasil penyimpanan belum dapat dipastikan. Hubungi admin sistem sebelum menyimpan ulang." });
            }
        } catch (error) {
            if (this.isCurrentAccountModal(sequence, schoolId)) this.setState({ saveError: unresolvedSaveMessage });
        } finally {
            this.finishAccountRequest(sequence, schoolId);
        }
    };

    render() {
        const idSekolah = this.state.idSekolah;
        const formLocked = this.state.isSaving || this.state.saveUncertain;
        return (
            <div className="wrapper">
                <LoaderModal isFetching={this.state.isFetching} />
                <Sidebar account={this.props.account} />
                <div id="content" style={{ paddingBottom: "50px" }}>
                    <Navbar title="Manajemen PSEP Akun Sekolah" />
                    {this.loadAlert()}
                    {this.state.saveNotice && <div role="status" className="alert alert-success">{this.state.saveNotice}</div>}
                    {idSekolah !== null && (
                        <Row>
                            <Col sm={12} className="text-right">
                                <button className="btn btn-success mb-3" onClick={this.handleOpenModal} disabled={this.state.isFetching || this.state.isSaving}>
                                    <li className="fa fa-plus"></li> Tambah
                                </button>
                            </Col>
                        </Row>
                    )}
                    <Row>
                        <Col sm={4}>
                            Provinsi
                            <Fragment>
                                <Select value={this.state.listProvinsi.find(row => String(row.value) === String(this.state.idProvinsi)) || null} options={this.state.listProvinsi} onChange={this.handleChangeSelect} placeholder="Pilih Provinsi..." />
                                <input tabIndex={-1} autoComplete="off" style={{ opacity: 0, height: 0 }} value={this.state.idProvinsi} required />
                            </Fragment>
                        </Col>
                        <Col sm={4}>
                            Kota/Kabupaten
                            <Fragment>
                                <Select value={this.state.listKabKota.find(row => String(row.value) === String(this.state.idKabKota)) || null} options={this.state.listKabKota} onChange={this.handleChangeSelect} placeholder="Pilih Kabupaten / Kota..." />
                                <input tabIndex={-1} autoComplete="off" style={{ opacity: 0, height: 0 }} value={this.state.idKabKota} required />
                            </Fragment>
                        </Col>
                        <Col sm={4}>
                            Sekolah
                            <Fragment>
                                <Select value={this.state.listSekolah.find(row => String(row.value) === String(this.state.idSekolah)) || null} options={this.state.listSekolah} onChange={this.handleChangeSelect} placeholder="Pilih sekolah..." />
                                <input tabIndex={-1} autoComplete="off" style={{ opacity: 0, height: 0 }} value={this.state.idSekolah} required />
                            </Fragment>
                        </Col>
                    </Row>
                    {this.loading()}
                    {this.state.selectionError && <div role="alert" className="alert alert-warning">{this.state.selectionError}</div>}
                    {idSekolah && <SchoolNpsnEditor key={idSekolah} schoolId={idSekolah} />}
                    <Row>
                        <Col xs={12} md={12}>
                            {this.renderTableSekolah()}
                        </Col>
                    </Row>
                </div>
                <Modal show={this.state.openModal} aria-labelledby="example-custom-modal-styling-title" size="lg" backdrop="static" keyboard={false}>
                    <Modal.Header>
                        <Modal.Title>Akun Sekolah</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <form onSubmit={this.handleSubmit}>
                            {this.state.saveError && <div role="alert" className="alert alert-warning">{this.state.saveError}</div>}
                            {this.state.isSaving && <div role="status">Memeriksa penyimpanan akun...</div>}
                            {this.state.saveUncertain && <Button type="button" variant="secondary" onClick={this.handleVerifySave} disabled={this.state.isSaving}>Periksa daftar akun</Button>}
                            <Row style={{ marginBottom: 40 }}>
                                <Col>
                                    <Input type="text" name="idAdmin" value={this.state.idAdmin || ""} disabled />
                                </Col>
                                <Col>
                                    <Input type="text" name="namaAdmin" onChange={this.handleChange} value={this.state.namaAdmin || ""} placeholder="Masukan Nama" disabled={formLocked} />
                                </Col>
                                <Col>
                                    <Input type="text" name="usernameAdmin" onChange={this.handleChange} value={this.state.usernameAdmin || ""} placeholder="Masukan Username" disabled={this.state.idAdmin != null || formLocked} />
                                </Col>
                            </Row>
                            <Row style={{ marginBottom: 40 }}>
                                <Col>
                                    <Input type="text" name="teleponAdmin" onChange={this.handleChange} value={this.state.teleponAdmin || ""} placeholder="Masukan Telepon" disabled={formLocked} />
                                </Col>
                                <Col>
                                    <Input type="text" name="emailAdmin" onChange={this.handleChange} value={this.state.emailAdmin || ""} placeholder="Masukan Email" disabled={formLocked} />
                                </Col>
                                <Col>
                                    <Input type="password" name="passwordAdmin" onChange={this.handleChange} value={this.state.passwordAdmin || ""} placeholder="Masukan Password" autoComplete="new-password" disabled={formLocked} />
                                </Col>
                            </Row>
                            <Grid item xs={12}>
                                <Button variant="danger" color="danger" type="button" style={{ float: "left" }} onClick={this.handleCloseModal}>
                                    <li className="fa fa-close"> Batal</li>
                                </Button>
                                <Button variant="primary" color="primary" type="submit" style={{ float: "right" }} disabled={formLocked}>
                                    <li className="fa fa-save"> Simpan</li>
                                </Button>
                            </Grid>
                        </form>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }

    loading = () => {
        if (this.state.isSearch) {
            return <Loader />;
        }
    };

    loadAlert = () => {
        const { alertShow } = this.state;
        if (alertShow) {
            return (
                <Alert variant="danger" onClose={() => this.setState({ alertShow: false })} dismissible>
                    <strong>{this.state.resMessage}</strong>
                </Alert>
            );
        }
    };

    renderTableSekolah() {
        return (
            <table className="table table-sm table-striped table-hover">
                <thead>
                    <tr>
                        <th style={{ "text-align-last": "center" }}>No</th>
                        <th>Nama Sekolah</th>
                        <th>Nama Admin User</th>
                        <th>Username</th>
                        <th style={{ "text-align-last": "center" }}>Level</th>
                        <th style={{ "text-align-last": "center" }}>Status</th>
                        <th style={{ "text-align-last": "center" }}>Last Login</th>
                        <th style={{ "text-align-last": "center" }}>Aksi</th>
                    </tr>
                </thead>
                <tbody>{this.renderChildSekolah()}</tbody>
            </table>
        );
    }

    renderChildSekolah() {
        if (!__.isEmpty(this.state.sekolah)) {
            return this.state.sekolah.akun.map((val, i) => {
                return (
                    <tr>
                        <td style={{ "text-align-last": "center" }}>{i + 1}.</td>
                        <td>{this.state.namaSekolah}</td>
                        <td>{val.namaAdminUser}</td>
                        <td>{val.username}</td>
                        <td style={{ "text-align-last": "center" }}>{val.type}</td>
                        <td style={{ "text-align-last": "center" }}>{val.status === "AKTIF" ? <button className="btn btn-sm btn-outline-primary">Aktif</button> : <button className="btn btn-sm btn-outline-danger">Non Aktif</button>}</td>
                        <td style={{ "text-align-last": "center" }}>{val.lastLogin}</td>
                        <td style={{ "text-align-last": "center" }}>
                            <button className="btn btn-info btn-sm" onClick={() => this.handleOpenModal(val)}>
                                <li className="fa fa-edit"></li>
                            </button>
                        </td>
                    </tr>
                );
            });
        }
    }

    // doHandleRegis = async (stt, val) => {
    //     this.setState({ isSearch: true });
    //     const handleBukaTutup = await akmApi
    //         .post(URL_AKM.AKTFKAN_NONAKTIFKAN_SNMPTN, {
    //             ["idSekolah"]: val.idSekolah,
    //             ["idKabupatenKota"]: val.idKabupatenKota,
    //             ["idProvinsi"]: val.idProvinsi,
    //             ["namaSekolah"]: val.namaSekolah,
    //             ["kodeJenjangSekolah"]: val.kodeJenjangSekolah,
    //             // ["tahunAjaranSnmptn"]: stt,
    //             ["registrationDateSnmptn"]: 0,
    //         })
    //         .catch(function (error) {
    //             console.error(error);
    //         });

    //     this.fetchSekolahRefres(this.state.namaSekolahSearch);

    //     this.setState({ isSearch: false });
    // };
}

const mapStateToProps = (state) => {
    return {
        account: state.account,
    };
};

export default connect(mapStateToProps, { cekCookies })(MgtPsepSekolah);
